module.exports = __webpack_public_path__ + "img/94113b7.jpg";